import React, { Fragment, useCallback, useRef } from 'react';
import Link from '../../components/Link';

const MultipleItemsRenderer = <TItem extends object>({
    item,
    colKey,
}: {
    item: TItem;
    colKey: string;
}): JSX.Element => {
    const ref = useRef<HTMLDivElement>(null);
    const visible = useRef<boolean>(false);
    const val = item[colKey];

    const toggleVisibility = useCallback((): void => {
        if (ref.current) {
            ref.current.style.display = visible.current ? 'none' : 'flex';
            visible.current = !visible.current;
        }
    }, []);

    return val.length > 1 ? (
        <>
            <Link onClick={toggleVisibility}>Multiple ({val.length})</Link>
            <div
                ref={ref}
                style={{ display: 'none', paddingTop: '8px', wordBreak: 'break-word' }}
            >
                <p style={{ padding: 0 }}>
                    {val.map((listItem, idx) => (
                        <Fragment key={idx}>
                            {listItem}
                            {idx + 1 === val.length ? '' : ', '}
                        </Fragment>
                    ))}
                </p>
            </div>
        </>
    ) : (
        <p style={{ padding: 0 }}>{val.length === 1 ? val[0] : ''}</p>
    );
};

export default MultipleItemsRenderer;
